import { createContext } from 'react';

/**
 * @typedef {object} ProductCatalogueContextReturn
 * @property {Record<string, CatalogueItem>} catalogue - The catalogue
 * @property {boolean} catalogueLoading - Whether the catalogue is loading
 * @property {Error | null} catalogueError - The error if the catalogue fails to load
 * @property {boolean} enabled - Whether the catalogue is enabled
 * @property {() => void} startCatalogue - Function to start the catalogue subscription
 */

export const ProductCatalogueContext = createContext({
  catalogue: /** @type {ProductCatalogueContextReturn['catalogue']} */ ({}),
  catalogueLoading: /** @type {ProductCatalogueContextReturn['catalogueLoading']} */ (false),
  catalogueError: /** @type {ProductCatalogueContextReturn['catalogueError']} */ (null),
  enabled: /** @type {ProductCatalogueContextReturn['enabled']} */ (false),
  startCatalogue: /** @type {ProductCatalogueContextReturn['startCatalogue']} */ (() => {}),
});
